module.exports = __webpack_public_path__ + "83d9281d9d2bbd72aaf518700525580b.svg";